import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ISchedules } from '../../services/journey.service';

interface CurrentSchedule {
  schedule: ISchedules | null;
}

const initialState: CurrentSchedule = {
  schedule: null
};

export const currentSchedule = createSlice({
  name: 'currentSchedule',
  initialState,
  reducers: {
    saveCurrentSchedule: (state, action: PayloadAction<{ schedule: ISchedules }>) => {
      state.schedule = action.payload.schedule;
    }
  }
});

export const { saveCurrentSchedule } = currentSchedule.actions;
export const currentScheduleReducer = currentSchedule.reducer;
